module.exports = __webpack_public_path__ + "img/vipBg.7ab192b9.png";